module.exports = __webpack_public_path__ + "media/images/icon/checked-gray-04fdb45a52a7f830de360423119bae01.png";